import { toAvailableLanguage } from './utils';
export var getLinkForLanguage = function getLinkForLanguage(links, id) {
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
  var linksById = links[id];

  if (!linksById) {
    throw new Error("link id ".concat(String(id), " does not exist"));
  }

  var linkByLanguage = linksById[toAvailableLanguage(language, linksById)];

  if (!linkByLanguage) {
    throw new Error("link id ".concat(String(id), " does not exist with default language"));
  }

  return linkByLanguage;
};